import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmMaximize = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-llm-maximize" data-icon="icon-llm-maximize" aria-hidden="true" {...props} ref={ref}><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/></svg>);
});

IconLlmMaximize.displayName = 'IconLlmMaximize';
